import { Directive, ElementRef, HostListener } from '@angular/core';
import {FormControlName} from '@angular/forms';

@Directive({
  selector: '[validateSpaceReactive]'
})

export class ValidateSpaceReactiveFormDirective {

  get formControl() {
    return this.ngControl.control;
  }

  constructor(
    private _el: ElementRef,
    private ngControl: FormControlName,
  ) { }

  @HostListener('keydown', ['$event']) onKeyDown(event): any {
    if(event.keyCode === 32) { // space
      let cursorPosition = event.target.selectionEnd;
      let appendSpace = true;

      const startStrings = this._el.nativeElement.value.toString().substring(0, event.target.selectionStart);
      const endStrings = this._el.nativeElement.value.toString().substring(cursorPosition, this._el.nativeElement.value.length);

      if(startStrings.endsWith(' ') || endStrings.startsWith(' ')){
        appendSpace = false;
      }

      const initialValue = startStrings + String.fromCharCode(event.keyCode) + endStrings;
      this._el.nativeElement.value = initialValue.replace(/  +/g, ' ');

      if (initialValue.startsWith(' ')) {
        this._el.nativeElement.value = initialValue.trim();
      }

      this._el.nativeElement.selectionEnd = appendSpace ? cursorPosition + 1 : cursorPosition;

      event.preventDefault();
    }
  }

  @HostListener('blur', ['$event'])
  onBlur() {
    this._el.nativeElement.value = this._el.nativeElement.value.replace(/  +/g, ' ');
    this._el.nativeElement.value = this._el.nativeElement.value.trim();
    this.formControl.patchValue(this._el.nativeElement.value);
  }

}
